import { createIcon } from '@chakra-ui/icons';

export const TrackVideo = createIcon({
  displayName: 'TrackVideo',
  viewBox: '0 0 20 20',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#FDE9C8" />
      <g clipPath="url(#clip0_308_4083)">
        <path
          d="M14.0625 5.9375H5.9375C5.59232 5.9375 5.3125 6.21732 5.3125 6.5625V13.4375C5.3125 13.7827 5.59232 14.0625 5.9375 14.0625H14.0625C14.4077 14.0625 14.6875 13.7827 14.6875 13.4375V6.5625C14.6875 6.21732 14.4077 5.9375 14.0625 5.9375Z"
          stroke="#977334"
          strokeWidth="0.83"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.4375 7.8125L11.875 10L8.4375 12.1875V7.8125Z"
          stroke="#977334"
          strokeWidth="0.83"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_308_4083">
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
